import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EventManager, JhiLanguageService, AlertService } from 'ng-jhipster';
import { Enrollment } from './enrollment.model';
import { EnrollmentService } from './enrollment.service';
import { PaymentItem, PaymentItemService} from '../payment-item/';
import { CRUD_ACTIONS } from '../../shared';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';


@Component({
    selector: 'jhi-enrollment-detail',
    templateUrl: './enrollment-detail.component.html'
})
export class EnrollmentDetailComponent implements OnInit, OnDestroy {

    enrollment: Enrollment;
    private subscription: any;
    private enrollmentSubscription: any;
    private paymentItemSubscription: any;
    paymentItems: PaymentItem[];
    paymentItemsTotalAmount = 0;
    readonly MAX_PAYMENT_ITEMS = 50;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private enrollmentService: EnrollmentService,
        private eventManager: EventManager,
        private paymentItemService: PaymentItemService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['enrollment', 'payment', 'paymentType',
        'paymentItem']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });

        this.enrollmentSubscription = this.eventManager
                .subscribe('enrollmentListModification',
                (response) => {
                    this.enrollment = response['content']['content'];
                });
        this.paymentItemSubscription = this.eventManager
        .subscribe('paymentItemListModification', (response) => {
            this.handleActionResult(response.content);
        });
    }

    private handleActionResult(result: { action: string, content: any }) {
        switch (result.action) {
            case CRUD_ACTIONS.CREATE:
                this.paymentItems.push(result.content);
                this.calculateTotalAmount();
                break;
            case CRUD_ACTIONS.UPDATE:
                for (let index = 0; index <= this.paymentItems.length - 1; index++) {
                    let currentItem = this.paymentItems[index];
                    if (currentItem.id === result.content.id) {
                        this.paymentItems[index] = result.content;
                        this.calculateTotalAmount();
                        break;
                    }
                }
                break;
            case CRUD_ACTIONS.DELETE:
                for (let index = 0; index <= this.paymentItems.length - 1; index++) {
                    if (this.paymentItems[index].id === result.content.id) {
                        this.paymentItems.splice(index, 1);
                        this.calculateTotalAmount();
                        break;
                    }
                }
                break;
        }
    }

    load(id) {
        this.enrollmentService.find(id).subscribe(enrollment => {
            this.enrollment = enrollment;
            this.loadPaymentItems(enrollment.id);
        });
    }
    previousState() {
        window.history.back();
    }

    private loadPaymentItems(id: number) {
        this.paymentItemService.search({
            query: 'enrollment.id:' + id,
            size: this.MAX_PAYMENT_ITEMS,
            sort: ['payment.id', 'desc']
        }).subscribe(
            (res: HttpResponse<PaymentItem[]>) => this.onPaymentItemSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
        );
    }

    private onPaymentItemSuccess(data, headers) {
        this.paymentItems = data;
        this.calculateTotalAmount();
    }

    private calculateTotalAmount() {
        this.paymentItemsTotalAmount = 0;
        this.paymentItems.forEach((paymentItem) => {
            this.paymentItemsTotalAmount += paymentItem.amount;
        });
    }

    private onError(error: HttpErrorResponse) {
        this.alertService.error(error.error, null, null);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.enrollmentSubscription.unsubscribe();
        this.paymentItemSubscription.unsubscribe();
    }



}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/enrollment/enrollment-detail.component.ts